import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";

import { EBreadcrumbsState, TBreadcrumbItem } from "@app/shared/components/breadcrumbs/types/breadcrumbs.type";
import { TranslatePipe } from "@ngx-translate/core";
import { SkeletonComponent } from "@app/shared/components/skeleton/skeleton.component";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, TranslatePipe, SkeletonComponent],
  standalone: true,
})
export class BreadcrumbsComponent {
  state = input<EBreadcrumbsState>(EBreadcrumbsState.Show);
  items = input<TBreadcrumbItem[]>([]);

  readonly states = EBreadcrumbsState;
}
